import React, { Component } from "react";
import CoursesManageView from "../views/CoursesManageView";
import { withTranslation } from "react-i18next";
import { FormUtility, withRouter } from "cw-styleguide-react";
import qs from "qs";
import validate from "validate.js";
import constraints from "../constraints/CoursesManageFilterFormConstraints";
import { route } from "../../../routes";

class CoursesManageController extends Component {
  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);

    const parameters = this.convertParametersToFilters(
      this.props.location.search
    );

    const merged = {
      ...{
        courseId: "",
        courseTitle: "",
        courseGroupType: "",
        courseGroupLabel: "",
        courseGroupId: "",
        courseReviewDate: "",
        courseStatus: "",
        mainProviderId: "",
        mainProviderLabel: "",
        order: "rel",
        page: 1,
        groupSize: "10",
      },
      ...parameters,
    };

    // Set the initial state of the form filter values.
    this.state = {
      filterValues: merged,
      messages: new Set(),
    };

    // Bind functions to this.
    this.handleChange = this.handleChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
  }

  /**
   * componentDidMount.
   */
  componentDidMount() {
    this.props.clearCourse();
    this.props.resetInputLanguage();
    // Only clear the messages if we haven't just redirected here.
    if (this.props.redirect) {
      this.props.clearRedirect();
    } else {
      this.props.clearMessages();
      this.props.clearSelected();
    }
  }

  componentDidUpdate(prevProps) {
    // If redirected to itself then reload the pager
    // See https://dev.azure.com/ccdg/CWO%20-%20Courses/_workitems/edit/6425
    if (this.props.redirect !== prevProps.redirect) {
      if (this.props.redirect === route("coursesManage")) {
        this.props.clearRedirect();
        this.props.setReloadKey();
      }
    }
  }

  /**
   * Handle the form change event and set the values in the form state.
   * @param event
   */
  handleChange(event) {
    const values = { ...this.state.filterValues };
    this.setState({
      filterValues: FormUtility.setFormValues(event, values),
    });
    this.props.clearSelected();
  }

  /**
   * handleSubmit
   * @param event
   */
  handleSubmit(event) {
    const formErrors = validate(this.state.filterValues, constraints(), {
      fullMessages: false,
      format: "flat",
    });

    event.preventDefault();

    this.props.clearMessages();
    this.props.setReloadKey();
  }

  /**
   * Reset the filters.
   * @param event
   */
  handleReset(event) {
    this.setState({
      filterValues: {
        courseId: "",
        courseTitle: "",
        courseStatus: "",
        courseGroupType: "",
        courseGroupLabel: "",
        courseGroupId: "",
        courseReviewDate: null,
        mainProviderId: "",
        mainProviderLabel: "",
        order: "rel",
        page: 1,
        groupSize: "10",
      },
    });
    this.props.setReloadKey();
    this.props.clearSelected();
    this.props.clearMessages();
  }
  /**
   * convertParametersToFilters
   * @param parameters
   * @returns {any}
   */
  convertParametersToFilters(parameters) {
    const params = qs.parse(parameters, { ignoreQueryPrefix: true });

    // Remove empty parameter filters.
    Object.keys(params).forEach((key) => {
      params[key] = Array.isArray(params[key])
        ? new Set(params[key])
        : params[key];
      if (!params[key] || params[key].length === 0) {
        delete params[key];
      }
    });

    return params;
  }
  /**
   * convertFiltersToParameters
   * @param filters
   * @returns {string}
   */
  convertFiltersToParameters(filters) {
    let params = {
      courseId: filters.courseId,
      courseTitle: filters.courseTitle,
      courseStatus: filters.courseStatus,
      courseGroupType: filters.courseGroupType,
      courseGroupLabel: filters.courseGroupLabel,
      courseGroupId: filters.courseGroupId,
      courseReviewDate: filters.courseReviewDate,
      mainProviderId: filters.mainProviderId,
      mainProviderLabel: filters.mainProviderLabel,
      order: filters.order,
      groupSize: filters.groupSize,
      page: filters.page,
    };

    // Remove empty filter parameters.
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key].length === 0) {
        delete params[key];
      }
    });

    return qs.stringify(params, {
      addQueryPrefix: true,
      arrayFormat: "brackets",
    });
  }

  handleStateChange(data) {
    this.props.clearSelected();

    const values = { ...this.state.filterValues };

    values["order"] = data.order;
    values["groupSize"] = data.groupSize;
    values["page"] = data.page;

    let parameters = this.convertFiltersToParameters(values);

    this.props.clearRedirect();
    this.props.navigate(route("coursesManage") + parameters);
    this.props.setQuery(parameters);
  }

  render() {
    return (
      <CoursesManageView
        {...this.state}
        {...this.props}
        handleReset={this.handleReset}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleStateChange={this.handleStateChange}
      />
    );
  }
}

export default withRouter(withTranslation("local")(CoursesManageController));
